import type { Role } from "./enums.js";

/**
 * Matriz de permisos. El backend es la única autoridad: el frontend la usa solo
 * para ocultar acciones que de todos modos serían rechazadas (403).
 */
export const PERMISSIONS = [
  "mission.read",
  "mission.create",
  "mission.cancel",
  "mission.instruct",
  "approval.plan",
  "approval.delivery",
  "approval.budget",
  "agent.control",
  "project.manage",
  "repository.authorize",
  "policy.manage",
  "budget.manage",
  "settings.manage",
  "user.manage",
  "billing.import",
  /** Fase 5: pedir que se vuelva a comprobar el despliegue de una misión fusionada (solo observación; no despliega). */
  "deployment.recheck",
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const ALL = [...PERMISSIONS] as Permission[];

export const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  admin: ALL,
  operator: ["mission.read", "mission.create", "mission.cancel", "mission.instruct", "approval.plan", "approval.delivery", "agent.control", "deployment.recheck"],
  reviewer: ["mission.read", "approval.plan", "approval.delivery"],
  viewer: ["mission.read"],
};

export const can = (role: Role, p: Permission): boolean => ROLE_PERMISSIONS[role].includes(p);
